module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJ1BMVEVHcEyAgICAgICAgICAgICAgIB9fX2AgIB/f3+AgICAgICAgICAgICrUze4AAAADXRSTlMA+ePPpi0Qu04ehnDwwS7lggAAAIFJREFUCNdjYGDbJCioPYGBgSHkcIm7TSkDA6vRStaAWcoBDCkaDMFuDE1uDBsXMPSYMXBJMyhPYGgyY+A0YhBnADEYChlEGEBSDI4gRpMqiAGUShEOAEoBFbM5mgIVA7UzZFUAtQMNZGALABoItIKBAWQFQzjIUleg7ZwgZyQwAAAMSBvffpoUpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/time.png
// module id = PXKa
// module chunks = 1